// Token Value & Usage table — the cost (in tokens) of each AI-powered action.
// Imported by both the UI and the services that charge for actions.

export const TOKEN_COSTS = {
  resume_generation: 10,
  cover_letter: 7,
  job_automation: 5,
  application_submit: 3,
  ai_recommendations: 8,
  career_assessment: 5,
  interview_prep: 6,
  skill_analysis: 4,
} as const;

export type TokenAction = keyof typeof TOKEN_COSTS;

export const TOKEN_USAGE_EXAMPLES: { action: TokenAction; label: string; cost: number }[] = [
  { action: 'resume_generation', label: 'AI resume generation', cost: TOKEN_COSTS.resume_generation },
  { action: 'cover_letter', label: 'AI cover letter', cost: TOKEN_COSTS.cover_letter },
  { action: 'job_automation', label: 'Job application automation', cost: TOKEN_COSTS.job_automation },
  { action: 'application_submit', label: 'Submit an application', cost: TOKEN_COSTS.application_submit },
  { action: 'ai_recommendations', label: 'AI occupation recommendations', cost: TOKEN_COSTS.ai_recommendations },
  { action: 'career_assessment', label: 'Career assessment scoring', cost: TOKEN_COSTS.career_assessment },
  { action: 'interview_prep', label: 'Interview prep session', cost: TOKEN_COSTS.interview_prep },
  { action: 'skill_analysis', label: 'Skill gap analysis', cost: TOKEN_COSTS.skill_analysis },
];

/** Exchange rule: trade tokens for a free month of Career Transformer. */
export const EXCHANGE_RULE = {
  tokens: 5000,
  reward: '1 month of Career Transformer',
  targetTierId: 'transformer' as const,
};
